import { createSlice } from '@reduxjs/toolkit';
import { fetchMySavedPostIdsThunk, savePostThunk, unsavePostThunk } from './savedPostsActions';

const initialState = {
  postIds: [],
  groupPostIds: [],
  loading: false,
  fetchError: null,
  mutateError: null,
};

const savedPostsSlice = createSlice({
  name: 'savedPosts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMySavedPostIdsThunk.pending, (state) => {
        state.loading = true;
        state.fetchError = null;
      })
      .addCase(fetchMySavedPostIdsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.postIds = action.payload.post_ids || [];
        state.groupPostIds = action.payload.group_post_ids || [];
      })
      .addCase(fetchMySavedPostIdsThunk.rejected, (state, action) => {
        state.loading = false;
        state.fetchError = action.payload || 'Failed to load saved posts';
      })

      // Optimistic: the button flips immediately in the consuming component's
      // own local state, matching this codebase's established double-submit-
      // guard pattern (see GroupPosts.jsx's reactingKeys) -- this slice is
      // just the source of truth for "is X saved" on first load / refresh.
      .addCase(savePostThunk.fulfilled, (state, action) => {
        const { postId, groupPostId } = action.payload;
        if (postId != null && !state.postIds.includes(postId)) state.postIds.push(postId);
        if (groupPostId != null && !state.groupPostIds.includes(groupPostId)) state.groupPostIds.push(groupPostId);
      })
      .addCase(savePostThunk.rejected, (state, action) => {
        state.mutateError = action.payload || 'Failed to save post';
      })

      .addCase(unsavePostThunk.fulfilled, (state, action) => {
        const { postId, groupPostId } = action.payload;
        if (postId != null) state.postIds = state.postIds.filter((id) => id !== postId);
        if (groupPostId != null) state.groupPostIds = state.groupPostIds.filter((id) => id !== groupPostId);
      })
      .addCase(unsavePostThunk.rejected, (state, action) => {
        state.mutateError = action.payload || 'Failed to unsave post';
      });
  },
});

export default savedPostsSlice.reducer;
